import React, { useState } from 'react';
import { FaCopy, FaEye, FaEyeSlash } from "react-icons/fa";
import PropTypes from "prop-types";

const SecretText = ({ defaultSecret }) => {
  const [showSecret, setShowSecret] = useState(false);

  const handleShowSecret = () => {
    setShowSecret(!showSecret);
  };

  const handleCopySecret = () => {
    navigator.clipboard.writeText(defaultSecret);
  }

  return (
    <div>
      <span className="tw-text-blue-600">{
        showSecret ? defaultSecret : '***********************************'}
      </span>
      {showSecret ? (
        <FaEyeSlash className="tw-cursor-pointer tw-ml-2 tw-text-base" onClick={handleShowSecret} />
      ) : (
        <FaEye className="tw-cursor-pointer tw-ml-2 tw-text-base" onClick={handleShowSecret} />
      )}
      <FaCopy className="tw-cursor-pointer tw-ml-2 tw-text-base" onClick={handleCopySecret}/>
    </div>
  );
};

SecretText.propTypes = {
  defaultSecret: PropTypes.string.isRequired
};

export default SecretText;